module.exports = __webpack_public_path__ + "fd5f17a752de4c4b23f81c155392bcec.svg";